import { EnhancedButtonPrimeReact, EnhancedButtonPrimeReactSeverity, LabelPosition, RHookFormNumberFieldWithLabel } from "@websential/cosmic-v20";
import { FC, useEffect, useState } from "react";
import { Toolbar, useTheme } from "@mui/material";
import { federalT3InitialData, federalT3headerColumns } from "../globalVariablesconstants";

import { Calendar } from "primereact/calendar";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dropdown } from "primereact/dropdown";
import { InputNumber } from "primereact/inputnumber";
import { InputText } from "primereact/inputtext";

import { isEqual } from "lodash";

// import "./DataTableUI.css"







let emptyFederalT3Status = {
  id: null,
  fromA: null,
  toA: null,
  rateR: null,
  constantK: null,
};



interface IFederalT3DataTable {
  federalT3Data: (data: any) => void;
  TableDataGetById: any
}
export const FederalT3DataTable: FC<IFederalT3DataTable> = ({
  federalT3Data,
  TableDataGetById
}) => {
  const theme = useTheme()
  const [federalT3, setFederalT3] = useState<any>(federalT3InitialData);
  const [selectedFederalT3, setSelectedFederalT3] = useState<any>(null);
  const [empStatus, setEmpStatus] = useState(emptyFederalT3Status);

  // useEffect(() => {
  //   federalT3Data(federalT3);
  // }, [federalT3]);

  useEffect(() => {
    if (!isEqual(federalT3, TableDataGetById)) {
      federalT3Data([...federalT3]);
    }
  }, [federalT3]);

  useEffect(() => {
    if (TableDataGetById) {
      setFederalT3(TableDataGetById);
    }
     else {
          setFederalT3(federalT3InitialData)
        }

  }, [TableDataGetById]);

  const findIndexById = (id: string | number | any) => {
    let index = -1;

    for (let i = 0; i < federalT3.length; i++) {
      if (federalT3[i].id === id) {
        index = i;
        break;
      }
    }

    return index;
  };

  const createId = () => {
    let id = '';
    let chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

    for (let i = 0; i < 5; i++) {
      id += chars.charAt(Math.floor(Math.random() * chars.length));
    }

    return id;
  };

  const openNew = () => {
    // alert("new")

    let _federalT3 = [...federalT3];
    let _empStatus: any = { ...empStatus };

    if (empStatus.id) {
      const index = findIndexById(empStatus.id);

      _federalT3[index] = _empStatus;
    } else {
      _empStatus.id = createId();
      _federalT3.push(_empStatus);
    }



    setFederalT3(_federalT3);
    setEmpStatus(emptyFederalT3Status);
  };
  const resetData = () => {
    setFederalT3(federalT3InitialData.map((item) => ({ id: item.id, item: null })));
    // setFederalT3(
    //   federalT3InitialData.map((item:any) => {
    //     const { id } = item;
    //     const resetItem = Object.fromEntries(
    //       Object.keys(item).map((key) => [key, key === "id" ? id : null])
    //     );
    //     return resetItem;
    //   })
    // );


    // setFederalT3(federalT3InitialData);

  };


  // const confirmDeleteSelected = () => {
  //   let _federalT3 = federalT3.filter((val:any) => !selectedFederalT3.includes(val));
  //   setFederalT3(_federalT3);
  //   setSelectedFederalT3(null);
  // };

  // const onMoveUpClickHandler = () => {
  //   let newData = [...federalT3];
  //   const selectedIndices = selectedFederalT3.map((item:any) => 
  //     newData.findIndex((dataItem) => dataItem.id === item.id)
  //   );

  //   selectedIndices.forEach((index:any) => {
  //     if (index > 0) {
  //       [newData[index - 1], newData[index]] = [newData[index], newData[index - 1]];
  //     }
  //   });
  //   setFederalT3(newData);

  // };
  // const onMoveDownClickHandler = () => {
  //   let newData = [...federalT3];
  //   const selectedIndices = selectedFederalT3
  //     .map((item:any) => newData.findIndex((dataItem) => dataItem.id === item.id))
  //     .sort((a:any, b:any) => b - a); 

  //   selectedIndices.forEach((index:any) => {
  //     if (index < newData.length - 1) {
  //       [newData[index], newData[index + 1]] = [newData[index + 1], newData[index]];
  //     } 
  //   });
  //   setFederalT3(newData);

  // };


  // const onCellValueChange = (event: any, rowIndex: number, field: any) => {

  //   const updatedData = [...federalT3];


  //   updatedData[rowIndex][event.field] = field;

  //   // setFederalT3(updatedData);
  // };

  const onCellValueChange = (event: any, rowIndex: number, field: any) => {
    // setFederalT3((prev: any) => {
    //   const updatedData = [...prev];
    //   updatedData[rowIndex][event.field] = field;
    
    //   return updatedData;
    // });
    setFederalT3((prev: any) => {
      const updatedData = [...prev];
      const updatedRow = { ...updatedData[rowIndex], [event.field]: field };
      updatedData[rowIndex] = updatedRow;
      return updatedData;
    });
  };


  // const renderErrorClass = (field: any, rowIndex: number, rowData: any) => {
  //   if (field.field === "date") {
  //     if (rowData.status !== "" && rowData.status !== undefined && rowData.status !== null) {
  //       if(rowData.date === null){
  //         return "p-component p-filled calender-error-input"; 
  //       } else if(rowData.date === ""){
  //         return "p-component p-filled calender-error-input"; 
  //       }
  //     }
  //   } else {
  //     return "p-component p-filled input-dropdown-fields";
  //   }
  // };

  const columnsBody = (rowData: any, row: any, x: any) => {
    // if(x.field === 'notes'){
    //   return (
    //     <InputText
    //         value={rowData[x.field]}
    //         onChange={(e: any) =>
    //           onCellValueChange(x, row.rowIndex, e.target.value)
    //         }
    //         placeholder="Write notes here"
    //         className={renderErrorClass(x, row.rowIndex, rowData)}
    //       />
    //     )
    // }
    return (
      <InputNumber
        value={rowData[x.field]}
        onValueChange={(e: any) => onCellValueChange(x, row.rowIndex, e.value)}
        placeholder={"0.00"}
        minFractionDigits={2}
        maxFractionDigits={10}

        inputStyle={{
          textAlign: "right",
        }}
      />
    )
  }
  return (
    <>
      <div className="card">
        <Toolbar sx={{ justifyContent: "end", paddingRight: "0!important" }}>
          <>
            <EnhancedButtonPrimeReact
              label="Add"
              raised
              onClickHandler={openNew}
              style={{ marginLeft: "1rem" }}
              severity={EnhancedButtonPrimeReactSeverity.Secondary}
            />
            <EnhancedButtonPrimeReact
              label="Clear Data"
              raised
              onClickHandler={resetData}
              style={{ marginLeft: "1rem" }}
              severity={EnhancedButtonPrimeReactSeverity.Warning}
            />
          </>
        </Toolbar>
        <DataTable
          value={federalT3}
          // selection={selectedFederalT3} 
          // onSelectionChange={(e) => setSelectedFederalT3(e.value)}
          dataKey="id"
          showGridlines
          className="DataTableUI"
          editMode="cell"
          resizableColumns
          columnResizeMode="expand"
          scrollable
          // reorderableColumns
          filterDisplay="menu"
          // selectionMode="checkbox"
          scrollHeight="516px"
        >
          {/* <Column
                      selectionMode="multiple"
                      // hidden={!showChecboxColumn}
                      frozen={true}
                      resizeable={false}
                      style={{ 
                        width: "36px",
                        textAlign: "center",
                        // zIndex:1,
                        borderRight:"1px solid #e5e7eb",
                        top:0
                       }}
                      field="selection"
                      columnKey="selection"
                      className="selectionHeader"
                      // headerStyle={{zIndex:'2!important'}}
                    /> */}
          {federalT3headerColumns.map((x: any, index: any) => {
            return (
              <Column
                key={index}
                field={x.field}
                header={x.headerName}
                headerTooltip={x.description}
                headerTooltipOptions={{ position: "top" }}
                // sortable={false}
                // resizeable={x.resizable}
                // dataType={x.type}
                align={x.align}
                alignHeader={x.headerAlign}
                // reorderable={x.disableReorder}
                // exportable={x.disableExport}
                frozen={x.frozenColumn}
                columnKey={x.field}
                style={{
                  width: x.minWidth,
                  fontSize: "0.875rem",
                }}
                footer={x.footer}
                body={(rowData: any, row: any) => columnsBody(rowData, row, x)}
              />
            );
          })}
        </DataTable>
      </div>
    </>
  );
};
